import React from 'react';
import ColorLibrary from '../components/color-library/ColorLibrary';
import { ColorLibraryData } from '../types/ColorLibraryModel';

interface ColourLibraryModuleProps {
  moduleName: string;
  props: ColorLibraryData & {
    colours?: any[];
    effects?: string[];
    seasons?: any[];
  };
  id: string;
}

const ColourLibraryModule: React.FC<ColourLibraryModuleProps> = ({ props }) => {
  return (
    <div className="colour-library-module">
      <ColorLibrary data={props} />
    </div>
  );
};

export default ColourLibraryModule;
